import React, { useMemo } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  Essentials,
  Paragraph,
  Heading,
  Bold,
  Italic,
  Underline,
  Link,
  List,
  BlockQuote,
  Table,
  TableToolbar,
  Indent,
  IndentBlock,
  Autoformat,
  PasteFromOffice,
  TextTransformation,
  MediaEmbed,
} from "ckeditor5";
import "ckeditor5/ckeditor5.css";

export function RichTextEditor({ data, onReady, onChange, onBlur, onFocus }) {
  const config = useMemo(
    () => ({
      licenseKey: "GPL",
      plugins: [
        Essentials,
        Paragraph,
        Heading,
        Bold,
        Italic,
        Underline,
        Link,
        List,
        BlockQuote,
        Table,
        TableToolbar,
        Indent,
        IndentBlock,
        Autoformat,
        PasteFromOffice,
        TextTransformation,
        MediaEmbed,
      ],
      toolbar: [
        "heading",
        "|",
        "bold",
        "italic",
        "underline",
        "link",
        "bulletedList",
        "numberedList",
        "|",
        "outdent",
        "indent",
        "|",
        "blockQuote",
        "insertTable",
        "mediaEmbed",
        "undo",
        "redo",
      ],
      table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
      },
    }),
    [],
  );

  return (
    <CKEditor
      editor={ClassicEditor}
      config={config}
      data={data}
      onReady={onReady}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
    />
  );
}
